import { EyeStroke, FileMultipleStroke, Pencil1Stroke, PlusStroke, Trash3Stroke } from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';
import { TEMPLATE_BASE64 } from '@/lib/templates-base64/GIA-MUA';
import { downloadBase64Excel } from '@/lib/template-downloader';

interface ActionBarProps {
  onAddClick: () => void;
  onEditClick: () => void;
  onDeleteClick: () => void;
  onCopyClick: () => void;
  onViewClick: () => void;
  onRefreshClick?: () => void;
  onImportFromExcel?: () => void;
  hasRowSelected?: boolean;
}

export const ActionBar: React.FC<ActionBarProps> = ({
  onAddClick,
  onEditClick,
  onDeleteClick,
  onCopyClick,
  onViewClick,
  onRefreshClick,
  onImportFromExcel,
  hasRowSelected = false
}) => {
  const handleDownloadExcelTemplate = () => {
    downloadBase64Excel(TEMPLATE_BASE64, 'Cập nhật giá mua.xlsx');
  };
  return (
    <ActionBarV2 titleComponent={<h1 className='text-xl font-bold'>Cập nhật giá mua</h1>}>
      <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAddClick} variant='primary' />
      <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEditClick} disabled={!hasRowSelected} />
      <ActionButtonV2 icon={Trash3Stroke} title='Xóa' onClick={onDeleteClick} disabled={!hasRowSelected} />
      <ActionButtonV2 icon={FileMultipleStroke} title='Sao chép' onClick={onCopyClick} disabled={!hasRowSelected} />
      <ActionButtonV2 icon={EyeStroke} title='Xem' onClick={onViewClick} disabled={!hasRowSelected} />

      <MenuButtonV2
        items={[
          {
            title: 'Refresh',
            icon: <AritoIcon icon={15} />,
            onClick: onRefreshClick || (() => {}),
            group: 0
          },
          {
            title: 'Cố định cột',
            icon: <AritoIcon icon={16} />,
            onClick: () => {},
            group: 0
          },
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={18} />,
            onClick: () => {},
            group: 1
          },
          {
            title: 'Tải mẫu Excel',
            icon: <AritoIcon icon={28} />,
            onClick: handleDownloadExcelTemplate,
            group: 1
          },
          {
            title: 'Lấy dữ liệu từ Excel',
            icon: <AritoIcon icon={29} />,
            onClick: onImportFromExcel || (() => {}),
            group: 1
          }
        ]}
      />
    </ActionBarV2>
  );
};

export default ActionBar;
